var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tool-media"},[_c('img',{staticClass:"field-media",class:{'scale-type':!_vm.media.ext_val_scaleType},attrs:{"src":require("@/assets/images/program/program_media_img.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }